import gsap, { Power3, Power4 } from 'gsap';

import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Shffl } from '../_app/cuchillo/components/Shffl';

export default class Voice {
    static instance = null;

    container = GetBy.id('Voice');
    holder = GetBy.class('__holder', this.container)[0];
    tick = 0;
    tickLight = 0;
    blur = 0.1;
    x = 0.5;
    y = 0;
    radius = 0.5;
    alpha = 0;
    power = 1;

    radio = 1;
    radioTo = 1;

    powerLight = 0;
    powerLightTo = 0;

    shffl = null;

    constructor() {
        if (Voice.instance) {
            return Voice.instance;
        }
        this.init();
        Voice.instance = this;

    }

    static getInstance(opts = {}) {
        if (!Voice.instance) {
            Voice.instance = new Voice(opts);
        }
        return Voice.instance;
    }

    show() {
        gsap.killTweensOf(this);
        this.container.style.display = 'flex';
        gsap.to(this.container, { y: 0, duration: .8, ease: Power4.easeOut });
    }

    hide() {
        gsap.killTweensOf(this);
        gsap.to(this.container, {
            y: Metrics.HEIGHT, duration: .8, ease: Power3.easeIn, onComplete: () => {
                this.container.style.display = 'none';
            }
        });
    }

    init() {
        this.resize();
    }

    talk(__val) {
        const template = `
            <div class='shffl'>
                <span class='main'>${__val}</span>
                <span class='effect' data-shffl data-exact-size>${__val}</span>
            </div>
        `;
        this.holder.innerHTML = template;

        if (this.shffl) this.shffl.dispose();

        const shffl = GetBy.selector('[data-shffl]', this.infoHolder)[0];
        this.shffl = new Shffl(shffl, {
            origin: Shffl.LEFT,
            exactSize: true,
            duration: .3,//Math.max(.5, Math.min(1, shffl.innerText.length / 25)),
            textFrom: '',
            textTo: shffl.innerText
        });
        this.shffl.play();
    }

    loop() {
        this.tick = this.tick + 1;

        return;

        //LA ANIMACION DE MOMENTO NO TOQUES
        //SEGURAMENTE METEREMOS EL SOL EN WEBGL      
        if (this.tick % 2 == 0) {
            this.radioTo = Maths.maxminRandom(110, 90) / 100;
        }

        if (this.tick % 4 == 0) {
            this.powerLightTo = Maths.maxminRandom(30, 10) / 100;
        }

        if (this.tick % 7 == 0) {
            const p = Maths.maxminRandom(105, 95) / 100;
            this.container.style.setProperty('--power', `${p}`);
        }

        this.radio = Maths.lerp(this.radio, this.radioTo, .1);
        this.powerLight = Maths.lerp(this.powerLight, this.powerLightTo, .1);

        this.container.style.setProperty('--radio', `${this.radio}`);
        this.container.style.setProperty('--power-light', `${this.powerLight}`);

        return;


        if (this.tick % 2 == 0) {
            this.material.uniforms.alpha.value = this.alpha;
            this.material.uniforms.blur.value = this.blur;
            this.material.uniforms.x.value = this.x;
            this.material.uniforms.y.value = this.y;
            this.material.uniforms.radius.value = this.radius;
        }
        if (this.tick % 4 == 0) {
            this.tickLight = this.tickLight + 1;
            this.material.uniforms.timeLight.value = this.tickLight;
        }
        if (this.tick % 7 == 0) {
            this.material.uniforms.time.value = Maths.maxminRandom(100, 0);
        }

        this.material.uniforms.power.value += (this.power - this.material.uniforms.power.value) * .06;
    }

    resize() {

    }

    dispose() {
        if (this.shffl) this.shffl.dispose();
    }
}
